import ButtonVariantEnum from '../enums/ButtonVariant'

const buttonVariantMacher = {
  'Primary': ButtonVariantEnum.primary,
  'Secondary': ButtonVariantEnum.secondary,
}

export default buttonVariantMacher
